module.exports = "<div class=\"configurations-json\">\n  <json-editor *ngIf=\"mode === modeCheck.DEFAULT\" [ngModel]=\"data.data\" jsonModal #staticModal=\"json-modal\"  [config]=\"{mode: 'view'}\" (change)=\"onChange($event)\">\n  </json-editor>\n  <json-editor *ngIf=\"mode === modeCheck.EDIT\" [ngModel]=\"data.data\" jsonModal #staticModal=\"json-modal\"  [config]=\"{mode: 'tree'}\" (change)=\"onChange($event)\">\n  </json-editor>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/configurations/configurations-json/configurations-json.component.html
// module id = ../../../../../src/app/configurations/configurations-json/configurations-json.component.html
// module chunks = main